<template>
    <div>
        <v-card elevation="0" v-if="tableloading" height="450px" width="100%">
            <v-row justify="center" align="center" class="fill-height">
                <v-col cols="6">
                    <v-progress-linear
                        indeterminate
                        rounded
                        height="6"
                        color="#B2C6C2"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </v-card>
        <v-card elevation="0" color="#B2C6C2" v-else>
            <v-data-iterator
                :items="items"
                :page.sync="page"
                :search="search"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :items-per-page="12"
                v-if="!directpostingsearch"
            >
                <template v-slot:header>
                    <v-toolbar dark color="#004236" class="mb-1">
                        <v-text-field v-model="search" clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Search" dense></v-text-field>&nbsp;
                        <template v-if="$vuetify.breakpoint.mdAndUp">
                            <v-select v-model="sortBy" flat solo-inverted hide-details :items="keys" prepend-inner-icon="mdi-sort" label="Sort by" dense></v-select>
                        </template>
                    </v-toolbar>
                </template>
                <template v-slot:default="props">
                    <v-row class="pa-1 ma-1">
                        <v-col v-for="item in props.items" :key="item.classnbr" cols="12" sm="12" md="6" lg="4">
                            <v-card width="550px">
                                <v-toolbar elevation="0">
                                    <v-toolbar-title class="subheading font-weight-bold">{{ item.title }}</v-toolbar-title>
                                </v-toolbar>
                                <v-list dense height="350px">
                                    <v-list-item
                                        v-for="(key, index) in filteredKeys"
                                        :key="index"
                                    >
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <v-list-item-content :class="{ 'green--text': sortBy === key.value }">
                                                    {{ key.text }}:
                                                </v-list-item-content>
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                                <v-list-item-content
                                                    class="align-end"
                                                    :class="{ 'green--text': sortBy === key.text }"
                                                >
                                                    {{ item[key.value] }}
                                                </v-list-item-content>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                                <v-card-actions>
                                    <v-btn color="#d7ae28" block @click="viewPosting(item)">View Posting</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:no-data>
                    <v-container style="height: 50vh;">
                        <v-row class="fill-height" align-content="center" justify="center">
                            <v-col class="text-subtitle-1 text-center" cols="12">
                                No available Postings
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-data-iterator>
            <v-card elevation="0" v-else height="45vh" width="100%" color="transparent">
                <v-row justify="center" align="center" class="fill-height">
                    <v-col cols="12" md="12" sm="12" class="text-h6 text-center">
                        {{ directpostingmessage }}
                    </v-col>
                    <v-col cols="3" md="5" sm="10">
                        <v-btn color="#d7ae28" block @click="loadallPostings">Load all active postings</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-dialog v-model="dialogview" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="#004236">
                        <v-toolbar-title>{{ selectedPosting["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon dark @click="closeViewDialog">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <ViewPosting v-if="dialogview" :item="selectedPosting" />
                    <br />
                </v-card>
            </v-dialog>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewPosting from "./ViewDetails.vue"

export default {
    components: {
        ViewPosting
    },
    props: {
        postingid: {
            required: false
        }
    },
    data () {
      return {
        host: location.hostname.toString(),
        tableloading: false,
        search: '',
        filter: {},
        sortDesc: true,
        page: 1,
        sortBy: 'postingstarttimestamp',
        keys: [
            {"text": "Term", "value": "term"},
            {"text": "Discipline", "value": "subject-resolved"},
            {"text": "Type", "value": "type"},
            {"text": "Course(s)", "value": "coursesText"},
            {"text": "Section(s)", "value": "sectionsText"},
            {"text": "Format", "value": "classformat"},
            {"text": "Posted at", "value": "startDate"},
            {"text": "Apply by", "value": "endDate"}
        ],
        items: [],
        dialogview: false,
        selectedPosting: {},
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
        selectedItem: {},
        directpostingsearch: false,
        directpostingmessage: ""
      }
    },
    computed: {
        filteredKeys () {
            return this.keys
        },
    },
    methods: {
        loadPostings(){
            const that = this;
            that.directpostingsearch = false;
            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingsget';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        modifyData(){
            const that = this;

            that.items.forEach(element => {   
                //Courses
                var courselist = "";
                var sections = "";
                var format = "";
                element["courses"].forEach(e => {
                    if(e["ssrcomponent"] == "LEC"){
                        courselist += e["catalognbr"]+", ";
                        sections += e["classsection"]+", ";
                        format += e["classformat"]+", ";
                    }
                });
                
                element["term"] = that.resolveTerm(element["strm"]);
                element["department"] = element["courses"][0]["academicdepartment"];
                element["coursesText"] = courselist.slice(0,-2);
                element["sectionsText"] = sections.slice(0,-2);
                element["subject-resolved"] = element["courses"][0]["subject-resolved"];
                element["postingstarttimestamp"] = Date.parse(element["startDate"]);
                element["classformat"] = format.slice(0,-2);
            });
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        viewPosting(item){
            const that = this;

            that.selectedPosting = item;
            that.dialogview = true;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        directPostingAccess(){
            const that = this;

            that.directpostingsearch = false;
            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=postingsget&data={"id":"'+that.postingid+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    that.tableloading = false;
                    if(!resultData.result.match(/^OK/i)){
                        that.directpostingsearch = true;
                        that.directpostingmessage = "Warning: "+resultData.message;
                    }else {
                        if(resultData.data.length == 1){
                            let element = resultData.data[0];

                            //Courses
                            var courselist = "";
                            var sections = "";
                            var format = "";
                            element["courses"].forEach(e => {
                                if(e["ssrcomponent"] == "LEC"){
                                    courselist += e["catalognbr"]+", ";
                                    sections += e["classsection"]+", ";
                                    format += e["classformat"]+", ";
                                }
                            });
                            
                            element["term"] = that.resolveTerm(element["strm"]);
                            element["department"] = element["courses"][0]["academicdepartment"];
                            element["coursesText"] = courselist.slice(0,-2);
                            element["sectionsText"] = sections.slice(0,-2);
                            element["subject-resolved"] = element["courses"][0]["subject-resolved"];
                            element["postingstarttimestamp"] = Date.parse(element["startDate"]);
                            element["classformat"] = format.slice(0,-2);

                            that.viewPosting(element);
                        }else {
                            that.directpostingsearch = true;
                            that.directpostingmessage = "Specified Posting expired or does not exist.";
                        }
                    }
                })
                .catch(function(err){
                    that.tableloading = false;
                    that.directpostingsearch = true;
                    that.directpostingmessage = "Error: "+err.toString();
                })
            //End of API calling
        },
        loadallPostings(){
            if (this.postingid) {
                this.$router.replace({path: '/jobpostings'});
            }
            
            this.loadPostings();
        },
        closeViewDialog(){
            const that = this;
            that.dialogview = false;
            that.loadallPostings();
        }
    },
    created(){
        const that = this;
        if (that.postingid) {
            that.directPostingAccess();
        }else {
            that.loadPostings();
        }
    },
    mounted(){
        const that = this;
        if (that.postingid) {
            that.directPostingAccess();
        }
    }
}
</script>